
import { useState, useEffect } from 'react'
import { useWebsocket } from './useWebsocket'


export const useRoom = ({ room_id }) => {
    const [options, setOptions] = useState([]);
    const [messages, setMessages] = useState([]);

    const proto = document.location.protocol == "http:" ? "ws" : "wss";
    const url = `${proto}://${document.location.host}/r/${room_id}`;

    let [connState, sendMsg] = useWebsocket(url, (jsonMsg) => {
        if (jsonMsg.Options !== undefined) {
            setOptions(jsonMsg.Options)
        } else {
            setMessages((msgs) => [...msgs, jsonMsg])
        }
    })

    return [connState, { Options: options, Messages: messages }, (option) => {
        sendMsg({ Selected: option })
    }]
}
